import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineComponent, ref, computed, watch, withDefaults } from "vue";
import { getStructure } from "@/request/view/personal";
import { useStore } from "vuex";

export interface Props {
  staff: string;
  multiple: boolean;
  disabled: boolean;
  appointDepartment?: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'staffName',
  props: {
    staff: { default: "" },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    appointDepartment: { default: () => [] }
  },
  emits: ["getChooseStaff"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const store = useStore();

// 指定部门
const useAppointDepartment = () => {
  const appointList = [];
  const ite = (iteList) => {
    iteList.forEach((item) => {
      if (item.children && item.children.length > 0) ite(item.children);
      if (props.appointDepartment.find((v) => item.structureName === v)) {
        appointList.push(item);
      }
    });
  };

  ite(store.state.noticeStaffData);
  return appointList;
};

// 删除user list
const useDeleteUserList = (list) => {
  const ite = (iteList) => {
    iteList.forEach((item) => {
      if (item.userList) delete item.userList;
      if (item.children && item.children.length > 0) ite(item.children);
    });
  };
  ite(list);
  return list;
};

const options = computed(() => {
  if (!props.appointDepartment)
    return useDeleteUserList(JSON.parse(JSON.stringify(store.state.noticeStaffData)));
  return useDeleteUserList(JSON.parse(JSON.stringify(useAppointDepartment())));
});

const staff = props.multiple ? ref([]) : ref(null);

const staffName = [];

const staffUserName = [];

const structureName = [];
// 将用户置入
const setStructureBuyUser = (list) => {
  list.forEach((item) => {
    item.structureName = item.nickName;
    item.id = `P${item.id}`;
  });
  return list;
};
// 获取session中员工数据
const getNoticeStaffBySession = () => {
  return new Promise((resolve, reject) => {
    const noticeStaffData = sessionStorage.getItem("noticeStaffData");
    resolve(noticeStaffData);
  });
};
// 获取服务器中的数据
const getNoticeStaffByRequest = () => {
  return new Promise((resolve, reject) => {
    getStructure().then((res) => {
      if (res.code === 200) {
        const flatten = (list) => {
          list.forEach((item) => {
            if (item.userList && item.userList.length > 0) {
              item.children.unshift(...setStructureBuyUser(item.userList));
            }
            if (item.children && item.children.length > 0) {
              flatten(item.children);
            }
          });
        };
        flatten(res.data);
        resolve(res.data);
      }
    });
  });
};
//
const setNoticeStaffData = (list) => {
  if (!list.length || list.length === 0) return;
  store.commit("SET_NOTICE_STAFF_DATA", list);
};
// 初始化数据
const initOptionsData = async () => {
  const sessionStaffData = await getNoticeStaffBySession();

  if (sessionStaffData !== null) {
    setNoticeStaffData(JSON.parse(sessionStaffData as any));
    return;
  }

  const requestStaffData = await getNoticeStaffByRequest();
  setNoticeStaffData(requestStaffData);
  sessionStorage.setItem("noticeStaffData", JSON.stringify(requestStaffData));
};

initOptionsData();

const searchStaff = (inputValue, treeNode) =>
  treeNode.props.structureName.indexOf(inputValue) !== -1;

const emit = __emit;

const handleSelectStaff = (value, node, extra) => {
  staffUserName.length = 0;
  structureName.length = 0;

  const selectStaff = props.multiple ? extra.checkedNodes : extra.selectedNodes;

  const fstaff = selectStaff.filter((item) => typeof item.key === "string");

  fstaff.forEach((item) => {
    staffUserName.push(item.props.nickName);
    const department = item.props.secondaryDepartment || item.props.firstLevelDepartment;
    structureName.push(department);
  });

  emit("getChooseStaff", {
    staffName,
    staffUserName,
    structureName,
  });
};

const handleChooseStaffChange = (value, label, extra) => {
  staffName.length = 0;
  staffName.push(...label);

  if (staffName.length === 0) {
    emit("getChooseStaff", {
      staffUserName: staffName,
    });
  }
};

const treeDefaultExpandedKeys = ref([1]);

const findStaffByNickName = (nickName, list) => {
  let staff;
  function ite(nickName, list) {
    list.forEach((item) => {
      if (item.nickName === nickName) {
        staff = item;
        return false;
      }

      if (item.children) {
        return ite(nickName, item.children);
      }
    });
  }
  ite(nickName, list);
  return staff;
};

if (props.staff) {
  props.staff.split(",").forEach((nickName) => {
    const findstaff = findStaffByNickName(nickName, options.value);

    if (!findstaff) return;

    staffUserName.push(...findstaff.nickName);
    if (props.multiple) {
      staff.value.push(findstaff.id);
    } else {
      staff.value = findstaff.id;
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_a_tree_select = _resolveComponent("a-tree-select")!

  return (_openBlock(), _createBlock(_component_a_tree_select, {
    value: _unref(staff),
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(staff) ? (staff).value = $event : null)),
    treeDefaultExpandedKeys: treeDefaultExpandedKeys.value,
    treeDefaultExpandAll: true,
    style: {"width":"100%","min-height":"32px","max-height":"200px","min-width":"70px"},
    "tree-data": options.value,
    filterTreeNode: searchStaff,
    "dropdown-style": { maxHeight: '400px', overflow: 'auto', width: '200px' },
    "tree-checkable": props.multiple,
    multiple: props.multiple,
    showSearch: true,
    onChange: handleChooseStaffChange,
    onSelect: handleSelectStaff,
    maxTagCount: 10,
    "allow-clear": "",
    replaceFields: {
      label: 'structureName',
      value: 'id',
      children: 'children',
    },
    "search-placeholder": "请选择人员",
    placeholder: "请选择人员",
    disabled: props.disabled
  }, null, 8, ["value", "treeDefaultExpandedKeys", "tree-data", "tree-checkable", "multiple", "disabled"]))
}
}

})